export default () => ({
  trigger: {
    name: 'product_specifications.focus_search',
    params: {},
  },
  config: {
    event: {
      name: 'select_input_field',
      params: {
        sub_feature: 'specifications',
        input_field: 'property_search_bar',
        status: 'focus',
        content: null,
      },
    },
  },
});
